import { render, staticRenderFns } from "./culturalPage.vue?vue&type=template&id=35311d98&scoped=true"
import script from "./culturalPage.vue?vue&type=script&lang=js"
export * from "./culturalPage.vue?vue&type=script&lang=js"
import style0 from "./culturalPage.vue?vue&type=style&index=0&id=35311d98&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35311d98",
  null
  
)

export default component.exports